import api from './api';

export const getMarks = async (examId, subjectId) => {
    try {
        const response = await api.get('/marks', { params: { exam_id: examId, subject_id: subjectId } });
        return response.data;
    } catch (error) {
        console.error("Error fetching marks:", error);
        throw error;
    }
};

// Get marks with flexible parameters
export const getMarksByFilters = async (params) => {
    try {
        const response = await api.get('/marks', { params });
        return response.data;
    } catch (error) {
        console.error("Error fetching marks:", error);
        throw error;
    }
};

// Get class-wise marks for all subjects
export const getClassReport = async (classId, examId) => {
    try {
        const response = await api.get('/marks/class-report', { 
            params: { class_id: classId, exam_id: examId } 
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching class report:", error);
        throw error;
    }
};

export const saveMarks = async (examId, subjectId, classId, totalMarks, marks) => {
    try {
        // --- THIS IS THE CORRECTED PAYLOAD ---
        const response = await api.post('/marks', { 
            exam_id: examId, 
            subject_id: subjectId, 
            class_id: classId,
            total_marks: totalMarks, // total_marks key should have the totalMarks value
            marks: marks              // marks key should have the marks array value
        });
        return response.data;
    } catch (error) {
        console.error("Error saving marks:", error);
        throw error;
    }
};

